export default "__VITE_ASSET__Cd7Vhl98__"